import { gql } from 'graphql-query-contracts';

export const createUnit = gql(`
  mutation CreateUnit($propertyId: UUID!, $unit: UnitInput!) {
    createUnit(propertyId: $propertyId, unit: $unit)
  }
`);
